import { ref, watch, toValue } from 'vue'

export function strapiQuery(query) {
  const data = ref([])
  const loading = ref(true)
  const error = ref(null)

  const headers = { 'Content-Type': 'application/json' }

  const fetchData = async (currentQuery) => {
    loading.value = true
    try {
      // strapiUrl is a compile-time global defined in vite.config.js
      const response = await fetch(`${strapiUrl}${currentQuery}`, {
        method: 'GET',
        headers
      })

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status} ${response.statusText}`)
      }

      const json = await response.json()
      data.value = json.data
    } catch (err) {
      error.value = err
      console.error(`Failed to fetch from ${currentQuery}:`, err)
    } finally {
      loading.value = false
    }
  }

  watch(
    () => toValue(query),
    (newQuery) => {
      if (newQuery) {
        fetchData(newQuery)
      }
    },
    { immediate: true }
  )

  return {
    data,
    loading,
    error,
    refetch: () => fetchData(toValue(query))
  }
}
